const headingSelector = 'h1, h2, h3';
const splitBlockSelector = 'p, ul, ol';

const isMatching = (node, selector) => Boolean(node?.matches?.(selector));

export const isHeading = (node) => isMatching(node, headingSelector);
export const isSplitBlock = (node) => isMatching(node, splitBlockSelector);
export const shouldAddDividerBefore = (block) =>
  isHeading(block) && isSplitBlock(block.previousElementSibling);

const isMeaningfulBlock = (node) => isHeading(node) || isSplitBlock(node);
const hasMeaningfulContent = (blocks) => blocks.some(isMeaningfulBlock);

const getHeadingSplitCandidates = (blocks) => blocks
  .map((block, index) => ({ block, index }))
  .filter(({ block, index }) => isHeading(block)
    && hasMeaningfulContent(blocks.slice(0, index))
    && hasMeaningfulContent(blocks.slice(index)));

const getBlockSplitCandidates = (blocks) => blocks
  .map((block, index) => ({ block, index: index + 1 }))
  .filter(({ block, index }) => isSplitBlock(block)
    && hasMeaningfulContent(blocks.slice(0, index))
    && hasMeaningfulContent(blocks.slice(index)));

export const getSplitCandidates = (blocks) => {
  const headingCandidates = getHeadingSplitCandidates(blocks);

  if (headingCandidates.length) {
    return { strategy: 'heading', candidates: headingCandidates };
  }

  return { strategy: 'block', candidates: getBlockSplitCandidates(blocks) };
};

export const shouldPreferLeftBalancedCandidate = (candidate, currentCandidate) => {
  if (!currentCandidate) {
    return true;
  }

  const candidateKeepsLeftAtLeastAsTall = candidate.leftHeight >= candidate.rightHeight;
  const currentKeepsLeftAtLeastAsTall =
    currentCandidate.leftHeight >= currentCandidate.rightHeight;

  if (candidateKeepsLeftAtLeastAsTall !== currentKeepsLeftAtLeastAsTall) {
    return candidateKeepsLeftAtLeastAsTall;
  }

  return candidate.heightDifference < currentCandidate.heightDifference;
};
